export default __webpack_public_path__ + "static/mast-b971cdc03d71a3d50d4436dcac182a67.png";